import { useRef, createRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import currencyFormatterGBP from '../../utils/currencyFormatterGBP'

const ProductPicker = ({ products, cmsProducts, currentProductId, onSelect }) => {
  const productsRef = useRef(products.map(() => createRef()))
  const [activeIndex, setActiveIndex] = useState(0)
  const parentRef = useRef()
  const [activeProductDom, setActiveProductDom] = useState(productsRef?.current?.[activeIndex])

  useEffect(() => {
    products?.forEach((product, index) => {
      if (currentProductId === product.id) {
        setActiveIndex(index)
        setActiveProductDom(productsRef?.current?.[index])
      }
    })
  }, [currentProductId, products])

  useEffect(() => {
    const scrollLeft = productsRef?.current?.[activeIndex]?.current?.offsetLeft || 0
    parentRef.current.scrollLeft = scrollLeft < 25 ? 0 : parentRef.current.scrollLeft + scrollLeft - 24
  }, [activeIndex, productsRef, activeProductDom])

  return (
    <div ref={parentRef} className="product-grid">
      {products?.map((product, index) => {
        const { id, name } = product
        const isActive = currentProductId === id

        return (
          <div className="product-grid-item" key={id} id={`product_${id}`}>
            <Button
              size="sm"
              className={`w-100 product-item font-sm text-start ${isActive ? 'selected' : 'default border'}`}
              onClick={() => {
                setActiveIndex(index)
                onSelect(id)
              }}
              ref={productsRef.current[index]}
            >
              <span className="product-name d-block">
                {cmsProducts?.find((cmsProduct) => cmsProduct?.productId === id)?.name || name}
              </span>
              <span className="d-flex align-items-center">
                <span className={`material-icons radio-icon me-2 ${isActive ? 'text-white' : 'text-primary'}`}>
                  {isActive ? 'radio_button_checked' : 'radio_button_unchecked'}
                </span>
                <span className={`fw-500 ${isActive ? 'text-white' : 'text-dark'}`}>
                  {currencyFormatterGBP(product.charge)}
                </span>
              </span>
            </Button>
          </div>
        )
      })}
    </div>
  )
}

ProductPicker.propTypes = {
  products: PropTypes.instanceOf(Array).isRequired,
  cmsProducts: PropTypes.instanceOf(Array).isRequired,
  currentProductId: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default ProductPicker
